import { render, staticRenderFns } from "./Spread.vue?vue&type=template&id=c771c236&scoped=true&"
import script from "./Spread.vue?vue&type=script&lang=js&"
export * from "./Spread.vue?vue&type=script&lang=js&"
import style0 from "./Spread.vue?vue&type=style&index=0&id=c771c236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c771c236",
  null
  
)

export default component.exports